export default __webpack_public_path__ + "logo13c87df0.png";